import React, { useState, useEffect } from 'react'
import {
  Table,
  Button,
  Input,
  Modal,
  Spin,
  Row,
  Col,
  Tooltip,
  Popconfirm,
} from 'antd'
import { EditOutlined, SearchOutlined, DeleteOutlined } from '@ant-design/icons'
import apiRequest from '../../hooks/ApiRequest'
import Layouts from '../../components/Layouts'
import BrokerForm from './AddEditAssigneUnderWriter'
import { toast } from 'react-toastify'
import CommonSearch from '../../hooks/Search'

const AssignBrokerList = () => {
  const [search, setSearch] = useState('')
  const [baseData, setBaseData] = useState([])
  const [loading, setLoading] = useState(false)
  const [modalVisible, setModalVisible] = useState(false)
  const [selectedID, setSelectedID] = useState(0)
  const [selectedUnderWriterID, setUnderWriterSelectedID] = useState()
  const [selectedInsurerID, setInsurerSelectedID] = useState()
  const [insurerList, setInsurerList] = useState([])
  useEffect(() => {
    fetchAssignedUnderWriter()
  }, [modalVisible])

  const fetchAssignedUnderWriter = async () => {
    setLoading(true)
    try {
      const insurers = await apiRequest(
        `${process.env.REACT_APP_BASE_URL_AUTH}/api/Auth/UsersForDropdown/insurer`,
        'GET',
      )
      const insurerIds = insurers?.data.map(ins => ins.id) || []
      localStorage.setItem('allInsurers', insurerIds.join(','))
      setInsurerList(insurers?.data || [])
      const userRole = JSON.parse(localStorage.getItem('roles'))
      const LoggedInUserId = localStorage.getItem('loggedInUserID')

      let userIdStr = []
      if (userRole === 'SuperAdmin') {
        userIdStr = insurerIds
      } else {
        userIdStr.push(parseInt(LoggedInUserId))
      }
      const payload = userIdStr

      const url = `${process.env.REACT_APP_BASE_URL_AUTH}/api/Auth/GetUserRelationship`
      const res = await apiRequest(url, 'POST', payload)
      debugger;
      if (res?.success) {
        setBaseData(res.data || [])
      } else {
        toast.error(res?.error || 'Failed to fetch assigned underwriters')
      }
    } catch (error) {
      console.error('Error fetching assigned underwriters:', error)
      toast.error('Something went wrong while fetching data')
    } finally {
      setLoading(false)
    }
  }

  const handleCreate = () => {
    let loggedInUserId = localStorage.getItem('loggedInUserID')
    let loggedInRole = JSON.parse(localStorage.getItem('roles'))
    setSelectedID(0)
    setUnderWriterSelectedID(0)
    if (loggedInRole === 'SuperAdmin') {
      setInsurerSelectedID(0)
    } else {
      setInsurerSelectedID(parseInt(loggedInUserId))
    }
    // setInsurerSelectedID(0);
    setModalVisible(true)
  }

  const handleEdit = recordId => {
    const record = baseData.find(item => item.id === recordId)
    if (record) {
      setUnderWriterSelectedID(record.assigneeId)
      setInsurerSelectedID(record.assignorId)
      setSelectedID(record.id)
      setModalVisible(true)
    }
  }

  const handleDelete = async (recordId, assigneeId) => {
    try {
      const response = await apiRequest(
        `${process.env.REACT_APP_BASE_URL_AUTH}/api/Auth/DeleteSubordinate/${recordId}/${assigneeId}`,
        'GET',
      )
      if (response.data.success) {
        toast.success('Underwriter assignment deleted successfully')
        await fetchAssignedUnderWriter()
      } else {
        toast.error(
          response.data.message || 'Failed to delete Underwriter assignment',
        )
      }
    } catch (error) {
      console.error('Error deleting Underwriter assignment:', error)
      toast.error('Error deleting Underwriter assignment')
    }
  }

  const handleModalClose = () => {
    setModalVisible(false)
    fetchAssignedUnderWriter()
  }

  const columns = [
    {
      title: 'Insurers',
      key: 'insurerName',
      render: (_, record) => `${record?.assignorName || 'N/A'}`,
    },
    {
      title: 'UnderWriter Name',
      key: 'underWriterName',
      render: (_, record) => `${record?.assigneeName || 'N/A'}`,
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (_, record) => (
        <>
          <Tooltip title="Edit Assignment">
            <Button type="primary" onClick={() => handleEdit(record.id)}>
              <EditOutlined />
            </Button>
          </Tooltip>
          <Popconfirm
            title="Are you sure to delete this claim limit?"
            onConfirm={() => handleDelete(record.id, record.assigneeId)}
            okText="Yes"
            cancelText="No">
            <Tooltip title="Delete">
              <Button type="danger" style={{ marginLeft: 8 }}>
                <DeleteOutlined />
              </Button>
            </Tooltip>
          </Popconfirm>
        </>
      ),
    },
  ]
  const handleSearch = value => {
    const filterTable = baseData.filter(o =>
      Object.keys(o).some(k =>
        String(o[k]).toLowerCase().includes(value.toLowerCase()),
      ),
    )
    setBaseData(filterTable)
  }
  const ClearSerach = () => {
    setSearch('')
    setBaseData(baseData)
    fetchAssignedUnderWriter()
  }
  return (
    <div
      title="Assign UnderWriter"
      className="ant-layout-content dashboard">
      <div className="dash-bg-white">
        <Row gutter={[16, 16]} align="middle">
          <Col xs={24} sm={24} md={24} lg={6} xl={12}>
            <div className="section-top-heading">
              <h3
                style={{ color: '#0C1362', fontWeight: '600', fontSize: '20px' }}>
                Assign Underwriter / Junior Underwriter / Claim Manager to Insurers
              </h3>
            </div>
          </Col>

          <Col xs={24} sm={24} md={12} lg={8} xl={5}>
            <CommonSearch
              value={search}
              onChange={e => setSearch(e.target.value)}
              onSearch={handleSearch}
              onClear={ClearSerach}
            />
          </Col>
          <Col xs={10} sm={10} md={6} lg={3} xl={3}>
            <div className="create-quotation">
              <Button
                type="primary"
                onClick={() => handleSearch(search)}
                style={{ marginLeft: 10 }}>
                Search
              </Button>
            </div>
          </Col>
          <Col xs={14} sm={14} md={6} lg={5} xl={4}>
            <div className="create-quotation">
              <Button type="primary" onClick={handleCreate}>
                Assign
              </Button>
            </div>
          </Col>
        </Row>
      </div>

      {loading ? (
        <Spin size="large" style={{ display: 'block', marginTop: 20 }} />
      ) : (
        <Table
          columns={columns}
          dataSource={baseData}
          rowKey="id"
        />
      )}
      <Modal
        title={
          selectedID
            ? 'Edit Underwriter / Junior Underwriter / Claim Manager Assignment'
            : 'Assign Underwriter / Junior Underwriter / Claim Manager'
        }
        centered
        visible={modalVisible}
        footer={null}
        onCancel={() => setModalVisible(false)}
        width={760}>
        <BrokerForm
          InsurerID={selectedInsurerID}
          UnderWriterID={selectedUnderWriterID}
          recordID={selectedID}
          onSuccess={handleModalClose}
          modalVisible={modalVisible}
        />
      </Modal>
    </div>
  )
}

export default AssignBrokerList
